import { OldHeading, SpecialSpan, OldText } from '@gassan-ui'
import { FC } from 'react'

type TudorLandingPageWatchmakingProps = {
  title: string
  preTitle: string
  description: string
  videoId: string
}

export const TudorLandingPageWatchmaking: FC<TudorLandingPageWatchmakingProps> = ({
  title,
  preTitle,
  description,
  videoId,
}) => {
  return (
    <div className="m-auto mb-16 grid w-full max-w-[2500px] bg-tudorShade-800 md:mb-24 lg:grid-cols-2">
      <div className="m-auto w-full px-4 py-8 text-center md:px-6 md:py-12 lg:w-3/4 lg:py-20 lg:text-left">
        <SpecialSpan variant="two" as="h6" color="white" mb="1">
          {preTitle}
        </SpecialSpan>
        <OldHeading
          variant="h2"
          as="h2"
          color="white"
          mb="3"
          fontWeight="medium"
          className="!leading-10"
        >
          {title}
        </OldHeading>
        <OldText variant="small" color="white" className="whitespace-pre-line">
          {description}
        </OldText>
      </div>
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${videoId}?showinfo=0`}
        title="Tudor watchmaking video"
        frameBorder="0"
        className="aspect-video h-full w-full lg:aspect-auto"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
